export const formatterTimePicker = (date, time) => {
  const [day, month, year] = date.split("/");
  const [hourMin, amPm] = time.split(" ");
  const [hour, minute] = hourMin.split(":");
  const realHour =
    amPm == "AM" ? hour : hour == 12 ? hour : parseInt(hour) + 12;
  return new Date(year, month - 1, day, realHour, minute);
};
